<app-headercontent [header]="header"></app-headercontent>
<div [@routeAnimation]="getAnimationData()">
  <router-outlet #outlet="outlet"></router-outlet>
</div>